(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid-marketing"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const CARDS_PER_PAGE = 24;

  function resetVisibility() {
    document.querySelectorAll('.product-grid__item').forEach(el => (el.style.display = ''));
  }

  function syncProductCount() {
    const section = document.querySelector('results-list[section-id]');
    if (!section) return;
    const cards = [...section.querySelectorAll('.product-grid__item')].filter(
      el => el.style.display !== 'none'
    );
    if (cards.length === 0) return;
    const count = cards.length;
    document.querySelectorAll('.products-count-wrapper span').forEach(el => {
      el.textContent = el.textContent.replace(/\d+/, count);
    });
    document.querySelectorAll('.facets__see-results').forEach(el => {
      el.textContent = el.textContent.replace(/\d+/, count);
    });
  }

  function getCardPage() {
    const params = new URLSearchParams(window.location.search);
    const p = parseInt(params.get('card_page'), 10);
    return Number.isInteger(p) && p > 0 ? p : 1;
  }

  function syncCardPagination() {
    const section = document.querySelector('results-list[section-id]');
    if (!section) return;

    const eligible = [...section.querySelectorAll('.product-grid__item')].filter(
      el => el.style.display !== 'none'
    );

    const totalPages = Math.max(1, Math.ceil(eligible.length / CARDS_PER_PAGE));
    let page = getCardPage();
    if (page > totalPages) page = totalPages;

    const start = (page - 1) * CARDS_PER_PAGE;
    const end = start + CARDS_PER_PAGE;

    eligible.forEach((card, i) => {
      if (i < start || i >= end) card.style.display = 'none';
    });

    renderCardPaginationNav(totalPages, page);
  }

  function renderCardPaginationNav(totalPages, currentPage) {
    const wrapper = document.querySelector('.product-grid-pagination-wrapper');
    if (!wrapper) return;

    if (totalPages <= 1) {
      wrapper.innerHTML = '';
      return;
    }

    const buildUrl = (page) => {
      const pageUrl = new URL(window.location.href);
      pageUrl.searchParams.set('card_page', page);
      return pageUrl.toString();
    };

    let html = '<nav class="pagination" role="navigation" aria-label="Pagination">';

    if (currentPage > 1) {
      html += `<a href="${buildUrl(currentPage - 1)}" class="pagination-prev" data-card-page="${currentPage - 1}">← Previous</a>`;
    }

    for (let p = 1; p <= totalPages; p++) {
      html += p === currentPage
        ? `<span class="pagination-link pagination-current" aria-current="page">${p}</span>`
        : `<a href="${buildUrl(p)}" class="pagination-link" data-card-page="${p}">${p}</a>`;
    }

    if (currentPage < totalPages) {
      html += `<a href="${buildUrl(currentPage + 1)}" class="pagination-next" data-card-page="${currentPage + 1}">Next →</a>`;
    }

    html += '</nav>';
    wrapper.innerHTML = html;
  }

  function syncAll() {
    resetVisibility();
    syncProductCount();
    syncCardPagination();
  }

  function runSync() {
    _observer.disconnect();
    syncAll();
    _observer.observe(document.body, { childList: true, subtree: true });
  }

  function goToCardPage(page) {
    const pageUrl = new URL(window.location.href);
    pageUrl.searchParams.set('card_page', page);
    history.pushState({}, '', pageUrl.toString());
    runSync();
    const section = document.querySelector('results-list[section-id]');
    if (section) section.scrollIntoView({ behavior: 'instant', block: 'start' });
  }

  document.addEventListener(
    'click',
    (e) => {
      const link = e.target.closest('[data-card-page]');
      if (!link) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      goToCardPage(parseInt(link.dataset.cardPage, 10));
    },
    { capture: true }
  );

  document.addEventListener('DOMContentLoaded', runSync, { once: true });

  let _syncTimer;
  const _observer = new MutationObserver(() => {
    clearTimeout(_syncTimer);
    _syncTimer = setTimeout(runSync, 50);
  });
  _observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('popstate', runSync);

  } catch(e) { console.error(e); }
})();
})();
